export default function Typography(theme) {
  return {
    MuiTypography: {
      styleOverrides: {
        h3: {
          color: theme.palette.primary.light
        },
        h4: {
          color: theme.palette.primary.light
        },
        h5: {
          color: theme.palette.primary.light
        },
        h6: {
          color: theme.palette.primary.light
        },
        menuDrawer: {
          color: theme.palette.common.white
        },
        tableCell: {
          color: theme.palette.common.black
        },
        tableHeaderCell: {
          color: theme.palette.common.black
        }
        // paragraph: {
        //   marginBottom: theme.spacing(2)
        // },
        // gutterBottom: {
        //   marginBottom: theme.spacing(1)
        // }
      }
    }
  };
}
